module.exports = __webpack_public_path__ + "1cdef3105194ed9f869776ee5ad05b55.pdf";